import { Card, CardBody, Typography } from "@material-tailwind/react";
import SideBar from "../../components/sidebar.tsx/SideBar";
import AuthService from "../../services/authService";
import React from "react";
import { useMutation } from "react-query";
import api from "../../services/apiService";

function Profile() {
  const userProfile = AuthService.user!.data;
  const fileInputRef = React.useRef<HTMLInputElement>(null);

  const uploadImage = async (imageFile: File) => {
    const formData = new FormData();
    formData.append("image", imageFile);
    const response = await api.post("/account/editProfilePicture", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  };
  const mutation = useMutation(uploadImage, {
    onSuccess: (data) => {
      AuthService.updateUserProfileImage(data.payload.data);
    },
    onError: (error) => {
      console.log(error);
    },
  });
  return (
    <div className="md:flex">
      <div className="bg-gray-100 h-full ">
        <SideBar />
      </div>
      <div className="flex-1 p-8">
        <Typography placeholder={undefined} className="text-2xl">
          Profile
        </Typography>
        <Typography placeholder={undefined} className="my-5">
          View your profile here
        </Typography>
        <Card placeholder={undefined} className="my-7">
          <CardBody
            placeholder={undefined}
            className="flex items-center justify-between "
          >
            <div className="flex">
              <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={(event) => {
                  if (event.target.files?.length) {
                    mutation.mutate(event.target.files[0]);
                  }
                }}
              />

              {userProfile.profilePictureUrl === undefined ? (
                <img
                  className="h-16 w-16 rounded-full object-cover object-center cursor-pointer"
                  src="https://images.unsplash.com/photo-1682407186023-12c70a4a35e0?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2832&q=80"
                  alt="Profile image"
                  onClick={() => fileInputRef.current?.click()}
                />
              ) : (
                <img
                  className="h-16 w-16 rounded-full object-cover object-center cursor-pointer"
                  src={userProfile.profilePictureUrl}
                  alt="Profile image"
                  onClick={() => fileInputRef.current?.click()}
                />
              )}
              <div className=" mx-4">
                <Typography placeholder={undefined} className="font-semibold">
                  {`${userProfile.firstName}  ${userProfile.lastName}`}
                </Typography>
                <Typography placeholder={undefined} className="text-gray-700">
                  Corporate company
                </Typography>
              </div>
            </div>
          </CardBody>
        </Card>

        <Card placeholder={undefined}>
          <CardBody placeholder={undefined}>
            <div className="flex justify-between items-center">
              <Typography placeholder={undefined} className="font-semibold">
                Personal Information
              </Typography>
            </div>
            <div className="gap my-5 grid md:grid-cols-2">
              <div className="mt-6">
                <Typography placeholder={undefined}>First Name</Typography>
                <Typography placeholder={undefined} className="font-semibold">
                  {userProfile.firstName}
                </Typography>
              </div>
              <div className="mt-6">
                <Typography placeholder={undefined}>Last Name</Typography>
                <Typography placeholder={undefined} className="font-semibold">
                  {userProfile.lastName}
                </Typography>
              </div>
              <div className="mt-6">
                <Typography placeholder={undefined}>Email</Typography>
                <Typography placeholder={undefined} className="font-semibold">
                  {userProfile.email}
                </Typography>
              </div>
              <div className="mt-6">
                <Typography placeholder={undefined}>Phone</Typography>
                <Typography placeholder={undefined} className="font-semibold">
                  {userProfile.phoneNumber}
                </Typography>
              </div>
              <div className="mt-6">
                <Typography placeholder={undefined}>Address</Typography>
                <Typography placeholder={undefined} className="font-semibold">
                  {userProfile.address}
                </Typography>
              </div>
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  );
}

export default Profile;
